import { GenerateKeysComponent } from "./generate-keys/generate-keys.component";
import { AdminProductListComponent } from "./product-list/product-list.component";

export const ADMINPORTAL_COMPONENTS = [GenerateKeysComponent, AdminProductListComponent];

export * from "./generate-keys/generate-keys.component";
export * from "./product-list/product-list.component";
